define('caccountContactsInfoTabView',[
  'module',
  'app',
  'marionette',
  'template!caccountContactsInfoTabTpl'
], function(
  module,
  App,
  Marionette,
  infoTabTpl
) {
  'use strict';

  var CAccountsContactsInfoTabView = Marionette.ItemView.extend({
    template: infoTabTpl,

    triggers: {
      'click @ui.editBtn' : '_onEditContactInfo'
    },

    ui: {
      editBtn: '.js-edit',
      phoneBtn: '.p-phone'
    },

    events: {
      'click @ui.phoneBtn': 'onBtnPhoneClick'
    },

    onBtnPhoneClick: function() {
      App.trigger('phone:numbering', { phoneNumber: this.model.get('tel') });
    },

    serializeData: function() {
      return this.model.toJSON();
    }
  });

  module.exports = CAccountsContactsInfoTabView;
});
